import React from 'react'
import { connect } from "react-redux";

import { useQuery, useQueryClient } from "react-query";
import { fetchArborescenceElementsParametres } from 'utils/queries';
import { deleteElementParametreArborescence, addElementParametreArborescence } from 'utils/posters';

import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import Typography from '@mui/material/Typography';

import DeleteElementDialog from './DeleteElementDialog';
import TableRowCollapse from './ElementRecursif';
import AddElementDialog from './AddElementDialog';


const LabelsArborescenceGestionParametreType = [
    'Autorisé SAV By Foussier',
    'Autorisé Retour Volontaire Rapido'
]


const Arborescence = ({ deleteElementParametreArborescence, addElementParametreArborescence }) => {

    /** Hook des éléments paramétrés */
    const [elements, setElements] = React.useState([]);

    /** Hook d'ouverture de la popin de suppression */
    const [dialogDelete, setDialogDelete] = React.useState({
        open: false,
        niveau: null,
        code: null,
        libelle: null,
        parametre: null
    });

    /** Hook d'ouverture d'ajout d'un élément */
    const [openAddDialog, setOpenAddDialog] = React.useState(false);

    const queryClient = useQueryClient();


    /** Handler de fermeture de l'ouverture de suppression */
    const handleOpenDeleteDialog = (niveau, code, libelle, parametre) => {

        setDialogDelete({
            open: true,
            niveau: niveau,
            code: code,
            libelle: libelle,
            parametre: {
                valeur: parametre,
                libelle: LabelsArborescenceGestionParametreType[parametre]
            }
        })
    }

    /** Handler de fermeture de la popin de suppression */
    const handleCloseDeleteDialog = () => {
        setDialogDelete({
            open: false,
            niveau: null,
            code: null,
            libelle: null,
            parametre: null
        })
    }

    /** Suppression d'un paramètre */
    const handleDeleteParameter = async (niveau, code, parametre) => {

        var result = await deleteElementParametreArborescence(niveau, code, parametre);

        if (result) {
            queryClient.refetchQueries("ArborescenceElementsParametres");
        }
    }

    /** Ouverture de la popin d'ajout d'un élément paramétré */
    const handleOpenAddDialog = () => {
        setOpenAddDialog(true);
    }

    /** Fermeture de la popin d'ajout d'un élément paramétré */
    const handleCloseAddDialog = () => {
        setOpenAddDialog(false);
    }

    /** Ajout d'un paramètre */
    const handleAddParameter = async (niveau, code, parametre) => {
        var result = await addElementParametreArborescence(niveau, code, parametre);

        if (!result) {
            return null;

        } else {
            queryClient.refetchQueries("ArborescenceElementsParametres");
        }

    }


    /** On récupère les éléments paramétrés de l'arborescence */
    const query = useQuery("ArborescenceElementsParametres", () => fetchArborescenceElementsParametres());

    React.useEffect(() => {
        if (!query.isLoading && !query.error && query.data) {
            setElements(query.data);
            // console.log(query.data);
        }
    }, [elements, query]);


    /** Définition des colonnes du tableau */
    const columns = [
        {
            label: 'Niveau',
            data: 'niveau',
            align: 'left'
        },
        {
            data: 'code',
            label: 'Code',
            align: 'left'
        },
        {
            data: 'libelle',
            label: 'Libellé',
            align: 'left'
        },

    ];

    return (
        <>
            <Stack direction='row' justifyContent="space-between">
                <Typography gutterBottom variant="h5" >
                    Administration de l'arborescence
                </Typography>

                <Button onClick={() => handleOpenAddDialog()}>
                    Nouveau
                </Button>
            </Stack>

            <Paper sx={{
                minWidth: 'fit-content',
                padding: 0,
                margin: 0,
                overflow: 'hidden'
            }}>
                <TableContainer sx={{ maxHeight: '62vh' }}>

                    <Table stickyHeader aria-label="sticky table" sx={{ width: '100%' }} size='small'>

                        <TableHead>
                            <TableRow key={`rowHead-0`}>
                                {columns.map((column) => (
                                    <TableCell
                                        key={`headCell-0-${column.data}`}
                                        align={column.align}
                                        sx={{ backgroundColor: theme => theme.palette.background.paper }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}

                                {LabelsArborescenceGestionParametreType.map((typeArbo, index) => {

                                    const randType = Math.floor(Math.random() * 1000);

                                    return (
                                        <TableCell
                                            key={`headCell-0-${index}-${randType}`}
                                            align='left'
                                            sx={{ backgroundColor: theme => theme.palette.background.paper }}
                                        >
                                            {typeArbo}
                                        </TableCell>
                                    )
                                })}

                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {
                                elements.map((row, index) => {

                                    return (
                                        <TableRowCollapse
                                            key={`rowCol-${index}`}
                                            row={row}
                                            columns={columns}
                                            columnsParameter={LabelsArborescenceGestionParametreType}
                                            onOpenDeleteDialog={handleOpenDeleteDialog}
                                            onClose={handleCloseDeleteDialog}
                                        />
                                    );
                                })}
                        </TableBody>

                    </Table>
                </TableContainer>

            </Paper >

            {
                dialogDelete.niveau && dialogDelete.code &&
                <DeleteElementDialog
                    open={dialogDelete.open}
                    niveau={dialogDelete.niveau}
                    code={dialogDelete.code}
                    libelle={dialogDelete.libelle}
                    parametre={dialogDelete.parametre}
                    onDeleteElement={handleDeleteParameter}
                    onClose={handleCloseDeleteDialog}
                />
            }
            {
                openAddDialog &&
                <AddElementDialog
                    open={openAddDialog}
                    onClose={handleCloseAddDialog}
                    onAddElement={handleAddParameter}
                    parametreTypes={LabelsArborescenceGestionParametreType}
                />
            }
        </>
    );
}

const mapDispatchToProps = {
    deleteElementParametreArborescence,
    addElementParametreArborescence
};


export default connect(null, mapDispatchToProps)(Arborescence);
